import { LogoFromLogo } from '../../logo';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { GitbookIcon } from './icon';

// This config file will be used for demo purposes only, and will be removed after Team 25
export const gitbookConfig: ThirdPartyConfig = {
	displayName: 'GitBook',
	id: 'gitbook',
	icon: LogoFromLogo(GitbookIcon, 'GitBook'),
	resourceType: 'gitbook-connector',
	integrationAri: 'ari:cloud:platform::integration/graph-test-app', // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
	requiresOauth: false,
	userNeedsOAuth: false,
	// This will only be enabled on the demo instance
	isEnabled: () => true,
};
